import React, { useCallback } from "react";
import T from "prop-types";

import { Icons } from "2g-icons";
import { reactComponentType } from "2g-types";

import { RendererHodinaInterval } from "b2b/renderers";
import { useRedirectToZadostDetail } from "b2b/redirects";

export function RezervaceTablePozadavek({
  pozadavek,
  textComponent: TextComponent
}) {
  const redirectToDetail = useRedirectToZadostDetail();
  const handleClick = useCallback(() => {
    redirectToDetail(pozadavek.idZadost);
  }, []);

  return (
    <div className="b2b-RezervaceTableContent-pozadavek" onClick={handleClick}>
      <TextComponent>
        <div className="b2b-RezervaceTableContent-pozadavekLabel">
          <RendererHodinaInterval
            hodinaOd={pozadavek.hodinaOd}
            hodinaDo={pozadavek.hodinaDo}
          />
          <span className="b2b-RezervaceTableContent-pozadavekZakaznik">
            {pozadavek.zakaznik.nazev}
          </span>
        </div>
        <div className="b2b-RezervaceTableContent-pozadavekPoznamky">
          {pozadavek.strojvedouci ? (
            <span className="b2b-RezervaceTableContent-pozadavekPoznamka b2b-RezervaceTableContent-pozadavekPoznamka--strojvedouci">
              <Icons.IdentityCard />
              <span title={pozadavek.strojvedouci}>
                {pozadavek.strojvedouci}
              </span>
            </span>
          ) : undefined}
          {pozadavek.poznamkaSpravce ? (
            <span className="b2b-RezervaceTableContent-pozadavekPoznamka b2b-RezervaceTableContent-pozadavekPoznamka--spravce">
              <Icons.Note2 />
              <span title={pozadavek.poznamkaSpravce}>
                {pozadavek.poznamkaSpravce}
              </span>
            </span>
          ) : undefined}
        </div>
      </TextComponent>
    </div>
  );
}

RezervaceTablePozadavek.propTypes = {
  textComponent: T.oneOfType([reactComponentType, T.oneOf([React.Fragment])]),
  pozadavek: T.object
};

export default React.memo(RezervaceTablePozadavek);
